import type { Activity, Tag } from '@gyym/sdk'

import { PROD_SITE_BASE_URL } from '../constants'
import type { Thing } from '../types'

interface BuildMentionsParams {
  tags?: Tag[]
  activities?: Activity[]
  station?: string
}

/**
 * Build mentions array from facility tags, activities, and station
 * Used for semantic relationships in JSON-LD
 */
export const buildMentions = ({
  tags,
  activities,
  station,
}: BuildMentionsParams): Thing[] => {
  const mentions: Thing[] = []

  // Add tags as mentions with search URLs
  if (tags && tags.length > 0) {
    for (const tag of tags) {
      mentions.push({
        '@type': 'Thing',
        name: tag.label,
        url: `${PROD_SITE_BASE_URL}/facilities/tags/${encodeURIComponent(
          tag.value,
        )}`,
      })
    }
  }

  // Add activities as mentions
  if (activities && activities.length > 0) {
    for (const activity of activities) {
      mentions.push({
        '@type': 'Thing',
        name: activity.name,
      })
    }
  }

  // Add station as TrainStation mention
  if (station) {
    // Avoid duplicating 駅 suffix if already present
    const stationName = station.endsWith('駅') ? station : `${station}駅`
    mentions.push({
      '@type': 'TrainStation',
      name: stationName,
    } as Thing)
  }

  return mentions
}
